export default {
  load: 'PRODUCTS_ACTIONS_LOAD',
  loadList: 'PRODUCTS_ACTIONS_LOAD_LIST'
}
